var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control-range slider",attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }